const PIK_DOMAINS = [
  'pik.ru',
  'pik-group.ru',
  'пик.рф',
  'alkor-uk.ru',
  'bimteam.ru',
  'butovo-prom.ru',
  'energoservis-pik.ru',
  'forma.ru',
  'geodesy-stroy.ru',
  'grad-lift.ru',
  'grandolimp.ru',
  'icdik.ru',
  'ingstroyinn.ru',
  'investaliance.ru',
  'ite-sd.ru',
  'keyrealestate.ru',
  'kovchegstroy.ru',
  'kuntsevo-invest.ru',
  'legrobuild.ru',
  'legrobuild.ru',
  'ligovsky-city.ru',
  'pik-arenda.ru',
  'pik-comfort.ru',
  'pik-digital.ru',
  'pik-element.ru',
  'pik-industry.ru',
  'pik-market.ru',
  'pik-remont.ru',
  'pik-upgrade.ru',
  'pik.digital',
  'pik.rent',
  'prefabtech.ru',
  'prostoresh.ru',
  'sigma-d.ru',
  'techmail.pik.ru',
  'uk-beta.ru',
  'vmassive-kval.ru',
  'vmassive.com',
  'vmassive.ru',
  'простыерешения.рус',
  'пикремонт.рф',
  'mar-grad.ru',
  'oknapik.ru',
  'one-sierra.com',
  'pik-group.com',
  'pikgroup.com',
  'pikplatform.ru',
  'rostovkapstroy.ru',
  'terbereg.ru',
  'uk-sirius.ru',
  'sp-kvartal.ru',
  'uk-razvitie36.ru',
  'ukkbu.ru',
  'ukservisekspert.ru',
  'vostokyunion.ru',
  'zhil-uyut.ru',
  'gkh-kupelinka.ru',
  'ukvityaz.ru',
  'uk-katyushki.ru',
  'uk-jks.ru',
  'serviskomfort36.ru',
  'ukgorodok36.ru',
  'ukkomservis36.ru',
  'uksferazhkkh.ru',
  'pik-comfortmaster.com',
  'pik-comfortmaster.pro',
  'pik-comfortmaster.ru',
  'pik-master.com',
  'pik-master.pro',
  'nd-pk.ru',
  'uk-vladimirskaya.ru',
  'zhrep8.ru',
  'uk-standartcity.ru',
  'pik-lk.ru',
  'ukdsb.ru',
  'uk-zsz.ru',
  'housmaster24.ru',
  'tps1exp.ru',
  'uprkomp.ru',
  'ukeliteservice.ru',
  'uk-dmitrov.ru',
  'plk.msk.ru',
  'dmitrov-uk.ru',
  '3rdtaxipark.ru',
  'aotechnostroy.ru',
  'baltfinstroy.ru',
  'bochakovskaya.ru',
  'borets-msk.ru',
  'broadstroy.ru',
  'bw-estate.ru',
  'centrpolis-sd.ru',
  'drsu-34.ru',
  'dskgrad.ru',
  'elitgradsd.ru',
  'faramant.ru',
  'galaktion-sd.ru',
  'gbiplant23.ru',
  'geopark-sd.ru',
  'grandtim.ru',
  'ligovsky-city.ru',
  'lublinodev.ru',
  'lzsmk.ru',
  'mcieassociation.ru',
  'megapolismsk.ru',
  'mezhregionopttorg.ru',
  'morton-rso.ru',
  'morton-yug.ru',
  'moskvoretskiy-dom.ru',
  'mpzhb-18.ru',
  'mstroymoscow.ru',
  'mt-development.ru',
  'nationalbuilding.ru',
  'new-gorizont.ru',
  'nm-konsalt.ru',
  'novohohlovskaya15.ru',
  'ooolotan.ru',
  'ooonikp.ru',
  'oooproject2.ru',
  'oooregioninvest.ru',
  'park-presnya.ru',
  'perspektivnye-resheniya.ru',
  'pik-blagoveshchensk.ru',
  'pik-primorye.ru',
  'pik-region.ru',
  'pik-sakhalin.ru',
  'pik-ural.ru',
  'plastpoliten-sd.ru',
  'profserviceorg.ru',
  'prometey-city.ru',
  'proyekt-stroy.ru',
  'rivas-mo.ru',
  'rozhdestvennoe.ru',
  'rusbiznesinvest.ru',
  'russtroygarant.ru',
  's-stroyperspectiva.ru',
  'sd-ac16.ru',
  'sd-altyn.ru',
  'sd-avangard.ru',
  'sd-derbenevskiy.ru',
  'sd-ecostroy.ru',
  'sd-ekstragrad.ru',
  'sd-filit.ru',
  'sd-glory.ru',
  'sd-gorizont.ru',
  'sd-izhorskaya.ru',
  'sd-kantemirovskaya.ru',
  'sd-mak8.ru',
  'sd-optimal.ru',
  'sd-ozernaya44.ru',
  'sd-plum.ru',
  'sd-rainbow.ru',
  'sd-simonovskaya.ru',
  'sd-sphera.ru',
  'sd-stadionspartak.ru',
  'sd-stolitsa.ru',
  'sd-stroydetal.ru',
  'sd-stroyexpert.ru',
  'sdlikhobory.ru',
  'sdserednevo.ru',
  'skytower-group.ru',
  'sokolnicheskiyval.ru',
  'solntsevo-park.ru',
  'speccvetmed.ru',
  'spektr-sd.ru',
  'stolichniy-complex.ru',
  'stroy-proj.ru',
  'stroykom-sd.ru',
  'sueholding.ru',
  'terbereg.ru',
  'tmp20-sd.ru',
  'tyrone.ru',
  'uk-sirius.ru',
  'volzhskiy-park.ru',
  'vostochnij.ru',
  'yasenevy-park.ru',
  'zagorodnaya-usadba.ru',
  'zaomonetchik.ru',
  'zapad-port.ru',
  'zemproektstroy.ru',
  'zhilindustriya.ru',
  'alkor-uk.ru',
  'uk-sirius.ru',
  'dmitrov-uk.ru',
  'exzhil.ru',
  'gkh-aprelevka.ru',
  'gkh-kupelinka.ru',
  'gks2nev.ru',
  'housmaster24.ru',
  'kommunalschik-anapa.ru',
  'lider37.ru',
  'mks-tomsk.ru',
  'mks-uu.ru',
  'nd-pk.ru',
  'nfzhkh.ru',
  'pik-comfortmaster.ru',
  'pik-comfort.ru',
  'pik-lk.ru',
  'remontnikserp.ru',
  'serpfregat.ru',
  'serviskomfort36.ru',
  'sksuprav.ru',
  'sokol-uk.ru',
  'soyuzm.ru',
  'svetlyykray.ru',
  'tekhnoff.ru',
  'ujfvostochnaya.ru',
  'uk-23m.ru',
  'uk-bes-sao.ru',
  'uk-dmitrov.ru',
  'ukdsb.ru',
  'ukeliteservice.ru',
  'ukgamma.ru',
  'ukgorodok36.ru',
  'uk-ivanovo.ru',
  'uk-jks.ru',
  'uk-katyushki.ru',
  'ukkbu.ru',
  'ukkomservis36.ru',
  'uk-mahallya.ru',
  'uk-razvitie36.ru',
  'uk-rus56.ru',
  'uk-sd.ru',
  'ukservisekspert.ru',
  'uksferazhkkh.ru',
  'uk-sinkovo.ru',
  'uk-solidarnost.ru',
  'uk-standartcity.ru',
  'uk-vladimirskaya.ru',
  'uk-zsz.ru',
  'upravlk.ru',
  'urap4.ru',
  'uytdom1.ru',
  'vostokyunion.ru',
  'zetservis.ru',
  'zhilkomserv.ru',
  'zhil-uyut.ru',
  'zhkhnara.ru',
  'zhrep8.ru',
  'жкх-56.рф',
  'pik-comfort.ru',
  'ukvityaz.ru',
  'plk.msk.ru',
  '100kgi.ru',
  '480kji.ru',
  'energoservis-pik.ru',
  'nss-pik.ru',
  'oknapik.ru',
  'pik-autotrans.ru',
  'pik-nss.ru',
  'pik-podyom.ru',
  'pik-rt.info',
  'butovo-prom.ru',
  'kvarta.ru',
  'mar-grad.ru',
  'sp-kvartal.ru',
  'one-sierra.com',
  'contech.pik.ru',
  'pik.digital',
  'pik.team',
  'pik.email',
  'lite-pik.ru',
  'lite-pik.com',
];

const FRAUD_DOMAINS = [
  'rusmedical@bk.ru',
  'ural-medik3@gexa.ru',
  'info@sok-atlant.ru',
  'gk-nx.ru',
  'futura-architects.com',
  '4339596@mail.ru',
  'k.lovchev@izmelchenie.com',
  'n.lazareva@tender-pik.online',
];

const findDomain = (host) => !!PIK_DOMAINS.find((v) => host === v);

const createUrl = (url) => {
  try {
    return new URL(url);
  } catch (error) {
    console.error(error);
  }

  return null;
};

const parseBaseUrl = (value) => {
  let urlValue = '';

  const urlMatches = value.match(/(\w[^.]+\.\w[^.:]+)$/gi);

  if (Array.isArray(urlMatches) && urlMatches.length) {
    // eslint-disable-next-line prefer-destructuring
    urlValue = urlMatches[0];
  }

  return urlValue;
};

const checkDomain = (value) => {
  try {
    const formattedValue = value.replace(/\s+/gi, '');

    const isEmail = /^\S+@\S+\.\S+$/i.test(formattedValue);

    if (isEmail) {
      const [, emailDomain] = formattedValue.split('@');

      const parsedEmailDomain = parseBaseUrl(emailDomain);

      return {
        correct: findDomain(parsedEmailDomain),
        host: emailDomain,
        isEmail: true,
      };
    }

    let urlValue = parseBaseUrl(formattedValue);
    const isUrl = /^(http:\/\/)|(https:\/\/)/gi.test(urlValue);

    if (!isUrl) {
      urlValue = `https://${urlValue}`;
    }

    const isRfDomain = /[ЁёА-я]+/gi.test(formattedValue);

    if (isRfDomain) {
      return {
        correct: findDomain(formattedValue),
        host: formattedValue,
        isDomain: true,
        isHttp: false,
      };
    }

    const url = createUrl(urlValue);

    if (url) {
      const { host, protocol } = url;

      return {
        correct: findDomain(host),
        host,
        isDomain: true,
        isHttp: protocol === 'http:',
      };
    }
  } catch (error) {
    console.error(error);
  }

  return {
    correct: false,
  };
};

// todo 12027 убрать проверку на точку если понадобится смотреть не только урл или почту
const checkValueLength = (value) => value && value.length >= 3 && value.indexOf('.') !== -1;

const fraudPrevention = (value) => {
  const checkLength = checkValueLength(value);

  if (checkLength) {
    const domain = checkDomain(value);

    if (domain.correct === true) {
      return {
        success: true,
        error: null,
        domain,
        text: 'Это надёжный ресурс',
        label: {
          icon: 'success',
          text: 'Безопасно',
        },
        resource: value,
      };
    }

    return {
      success: false,
      error: true,
      domain: null,
      text: 'Это могут быть мошенники',
      label: {
        icon: 'error',
        text: 'Небезопасно',
      },
      resource: value,
    };
  }

  return {
    success: null,
    error: null,
    text: '',
    domain: null,
  };
};

module.exports = fraudPrevention;
exports = module.exports;

exports.PIK_DOMAINS = PIK_DOMAINS;
exports.FRAUD_DOMAINS = FRAUD_DOMAINS;
exports.checkValueLength = checkValueLength;
